module.exports = __webpack_public_path__ + "media/components/location_popup/static/map-fb93a27ba8d5f780c4348c35729371a5.jpg";